import { useRouteParams as useRouteParamsBase } from '../../_hooks/useRouteParams';

interface RouteParams {
  clientId: string;
  goalId: string | null;
}

export const useRouteParams = () => {
  return useRouteParamsBase<RouteParams>();
};
